<template>
  <div class="pa-2 fill-height scroll-y">
    <RawdataDisplay v-if="parsedData != null" :data="parsedData" />
  </div>
</template>

<script>
import { OrgApi } from '@/models'
import brush from 'brush'
import Slicer from 'horus-parser/src/Slicer'
import RawdataDisplay from '../rawdata/RawdataDisplay'

export default {
  components: {
    RawdataDisplay
  },
  props: {
    value: {}
  },
  data() {
    return { rawdata: '', parsedData: null, fwVersion: '02' }
  },
  watch: {
    value() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      if (this.value == null) return null
      this.err = null
      this.rawdata == null

      let fetcher = new OrgApi(this.value.org.id),
        tid = this.value.mainTrip.id

      try {
        let str = await fetcher.get(`trips/${tid}/rawdata`)
        let bytes = brush.hexToBytes(str)

        let slicer = new Slicer(bytes, {
          startPointer: 0,
          keepBytesInLapses: true,
          keepBytesInFrames: true,
          lastFwVersion: parseInt(this.fwVersion, 16)
        })

        this.parsedData = slicer.slice()
        // console.log(this.parsedData)

        // Ajusta cada frame para ter o .payload e o .bytes
        this.parsedData.frames.forEach(f => {
          if (f.type == 'event') f.payload = f.event
          if (f.type == 'header') f.payload = f.header
          if (f.type == 'footer') f.payload = f.footer
          if (f.type == 'lapses') f.payload = f.lapses
          if (f.type == 'garbage') f.payload = {}

          if (f.type != 'lapses') f.payload.bytes = f.bytes
        })
      } catch (err) {
        this.err = err
      }
    }
  }
}
</script>

<style></style>
